var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.3,
    height: 13.3,
    viewBox: "0 0 13.3 13.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M11.765,12a.237.237,0,0,1-.169-.069L8.09,8.42a5.061,5.061,0,0,1-3.149,1.1A4.858,4.858,0,0,1,0,4.757,4.857,4.857,0,0,1,4.941,0,4.858,4.858,0,0,1,9.883,4.757,4.64,4.64,0,0,1,8.438,8.115l3.5,3.5a.222.222,0,0,1-.007.32A.236.236,0,0,1,11.765,12ZM4.941.453a4.395,4.395,0,0,0-4.47,4.3,4.395,4.395,0,0,0,4.47,4.3,4.4,4.4,0,0,0,4.471-4.3A4.4,4.4,0,0,0,4.941.453Z",
    transform: "translate(0.65 0.65)",
    fill: "none",
    stroke: "#261e55",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.c5c73c4adad28b137d417634d5330abb.svg";
export { ForwardRef as ReactComponent };